import PersonalSettings from './client-page';

export default function PersonalPage() {
  return <PersonalSettings />;
}
